module.exports = __webpack_public_path__ + "ac224a39c93b1fd9f4672f4ff8adb65f.jpg";